import {Component, Vue, Watch} from "vue-property-decorator";
import {AXIOS} from "@/lib/http-common";

@Component({})
export default class ActiveErrors extends Vue {

  public showErrorInfoDialog: boolean = false;
  public selectedError: any = null;
  public activeErrorsFooterProps: any = {"items-per-page-options": [5]};
  public recordingMaximized: boolean = false;
  public isResettingErrors: boolean = false;

  public resetErrors() {
    this.isResettingErrors = true;

    AXIOS.post("/error-log/reset-errors")
      .finally(() => {
        this.isResettingErrors = false;
      });
  }

  public showErrorInfo(error: any) {
    this.selectedError = error;
    this.showErrorInfoDialog = true;
  }

  public onRecordingMaximized(maximized: boolean) {
    this.recordingMaximized = maximized;
  }

  @Watch('showErrorInfoDialog')
  public onShowErrorInfoDialog() {
    if (!this.showErrorInfoDialog) {
      this.selectedError = null;
    }
  }

  /**
   * Active errors table headers
   *
   * @NOTE: This is a 'computed' (see VUE documentation) getter by syntax.
   *
   * @NOTE: We do this for table headers as the translation is dynamic data
   * (when a language changes, table headers for the DataTable component must be reset)
   */
  get activeErrorsTH() {
    return [
      {
        text: this.$t("activeErrors.tableHeaders.componentType"),
        value: "definition.componentType"
      },
      {
        text: this.$t("activeErrors.tableHeaders.id"),
        align: "left",
        sortable: false,
        value: "definition.errorId"
      },
      {
        text: this.$t("activeErrors.tableHeaders.level"),
        value: "definition.errorLevel"
      },
      {
        text: this.$t("activeErrors.tableHeaders.since"),
        value: "startDate"
      },
      {
        text: this.$t("activeErrors.tableHeaders.title"),
        value: "title"
      }
    ];
  }
}
